(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-custom"]) return;
  try {
    

  /*
   * ============================================================
   * 4ALLKIDS DESKTOP MENU
   * ============================================================
   *
   * Probleem dat hiermee wordt opgelost:
   *
   * Wanneer een dropdown open stond en daarna een ander
   * hoofdmenu werd geopend, bleef de vorige <details> ook open.
   *
   * Vanaf nu:
   * - maximaal één hoofdmenu tegelijk open;
   * - ander dropdownmenu openen = vorige sluiten;
   * - klikken op een normale navigatielink = dropdowns sluiten;
   * - klikken buiten de navigatie = dropdowns sluiten;
   * - Escape = dropdowns sluiten.
   */

  function initHmDesktopNavigation() {
    const navigation = document.querySelector('.hm-header__desktop .hm-nav');

    if (!navigation) return;

    const detailsElements = Array.from(
      navigation.querySelectorAll('.hm-nav__details')
    );

    const normalLinks = Array.from(
      navigation.querySelectorAll('.hm-nav__link')
    );

    if (!detailsElements.length) return;

    function closeAllMenus(exceptMenu = null) {
      detailsElements.forEach((details) => {
        if (details !== exceptMenu) {
          details.removeAttribute('open');
        }
      });
    }

    detailsElements.forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;

        closeAllMenus(details);
      });
    });

    normalLinks.forEach((link) => {
      link.addEventListener('click', () => {
        closeAllMenus();
      });
    });

    document.addEventListener('click', (event) => {
      if (!navigation.contains(event.target)) {
        closeAllMenus();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeAllMenus();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHmDesktopNavigation);
  } else {
    initHmDesktopNavigation();
  }


  /*
   * ============================================================
   * STICKY HEADER
   * ============================================================
   */

  if (!customElements.get('sticky-header')) {
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.header = document.querySelector('.section-header');

        if (!this.header) return;

        this.headerIsAlwaysSticky =
          this.getAttribute('data-sticky-type') === 'always';

        this.headerBounds = {};

        this.setHeaderHeight();

        window
          .matchMedia('(max-width: 990px)')
          .addEventListener(
            'change',
            this.setHeaderHeight.bind(this)
          );

        if (this.headerIsAlwaysSticky) {
          this.header.classList.add(
            'shopify-section-header-sticky'
          );
        }

        this.currentScrollTop = 0;

        this.onScrollHandler =
          this.onScroll.bind(this);

        window.addEventListener(
          'scroll',
          this.onScrollHandler,
          false
        );

        this.createObserver();
      }

      setHeaderHeight() {
        if (this.header) {
          document.documentElement.style.setProperty(
            '--header-height',
            `${this.header.offsetHeight}px`
          );
        }
      }

      disconnectedCallback() {
        window.removeEventListener(
          'scroll',
          this.onScrollHandler
        );
      }

      createObserver() {
        const observer =
          new IntersectionObserver((entries, obs) => {
            this.headerBounds =
              entries[0].intersectionRect;

            obs.disconnect();
          });

        observer.observe(this.header);
      }

      onScroll() {
        const scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop;

        if (
          scrollTop > this.currentScrollTop &&
          scrollTop > this.headerBounds.bottom
        ) {

          this.header.classList.add(
            'scrolled-past-header'
          );

          if (!this.headerIsAlwaysSticky) {
            this.header.classList.add(
              'shopify-section-header-hidden',
              'shopify-section-header-sticky'
            );
          }

        } else if (
          scrollTop < this.currentScrollTop &&
          scrollTop > this.headerBounds.bottom
        ) {

          this.header.classList.add(
            'scrolled-past-header',
            'shopify-section-header-sticky'
          );

          this.header.classList.remove(
            'shopify-section-header-hidden'
          );

        } else if (
          scrollTop <= this.headerBounds.top
        ) {

          this.header.classList.remove(
            'scrolled-past-header',
            'shopify-section-header-hidden',
            'shopify-section-header-sticky'
          );
        }

        this.currentScrollTop = scrollTop;
      }
    }

    customElements.define(
      'sticky-header',
      StickyHeader
    );
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
